<template>
  <div class="container">
<!--    <div class="sigaotitlebg">-->
<!--      <img src="../../assets/images/sigaotitlebg.png" width="100%" height="100%"/>-->
<!--      <div class="bgtitle">-->
<!--        <h1>公司简介</h1>-->
<!--        <span>ABOUT&nbsp;&nbsp;&nbsp;&nbsp;US</span>-->
<!--      </div>-->
<!--    </div>-->
    <div :class={banner:true,showBtn:btnFlage}>
      <template>
        <el-carousel arrow="always" class="bannerbox" :height="imgHeight + 'px'" style="width:100%">
          <el-carousel-item v-for="item in bannerList" :key="item.id">
            <div class="bannermain"><img ref="image" :src="item.url" width="100%" height="auto"/></div>
          </el-carousel-item>
        </el-carousel>
      </template>
    </div>
    <!-- <div class="navcontainer">
        <div class="navmain">
            <span>首页</span>
            <span>/</span>
            <span>走进思高</span>
            <span>/</span>
            <span style="color:rgb(73,129,243)">{{navName}}</span>
        </div>
    </div> -->
    <div class="sigaobody">
      <!-- 装饰部分 -->
      <!-- 正文 -->
      <div class="switchTab">
        <div class="tabMain">
          <div class="tabtitle">
            <ul>
              <!-- to="/cmpMainbusiness/operate" -->
              <li class="site" @click="site(0,'befintroduction','关于我们')"><span class="siteSpan">公司简介</span></li>
              <li class="site" @click="site(1,'team','公司团队')"><span class="siteSpan">公司团队</span></li>
              <li class="site" @click="site(2,'culture','企业文化')"><span class="siteSpan">企业文化</span></li>

            </ul>
          </div>
        </div>
        <div class="phoneTab">
          <el-collapse accordion>
            <el-collapse-item>
              <template slot="title" style="text-align:center">
                <span style="color: #000000">走进思高</span>
              </template>
              <div class="phoneTabTitle" @click="phoneLink('befintroduction')">
                <span>公司简介</span>
              </div>
              <div class="phoneTabTitle" @click="phoneLink('culture')">
                                    <span style="color: #000000">
                                        企业文化
                                    </span>
              </div>
              <div class="phoneTabTitle" @click="phoneLink('team')">
                                    <span style="color: #000000">
                                        公司团队
                                    </span>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="tabBody">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      navName: '',
      imgHeight:"800",
      bannerList:[],
      btnFlage:false

    }
  },
  methods: {
    initBanner(){
      let that=this;
      axios.get('http://www.thingo.com.cn/thingo-server/website/enterThingo/banner').then((res) => {
        that.bannerList = res.data.data;
        if (that.bannerList.length === 1) {
          that.btnFlage = true
        }
        window.addEventListener("resize",this.resize,true)
      })
    },
    initStyle(index) {
      let lis = document.querySelectorAll('.site')
      let spans = document.querySelectorAll('.siteSpan')
      let tag = index || 0
      if (this.navName === '走进思高') {
        tag = 0
      }
      for (let i = 0; i < lis.length; i++) {
        lis[i].style.borderBottom = '0 solid rgb(57,99,174)'
        spans[i].style.color = '#000000'
        spans[i].style.fontWeight = 500
      }
      spans[tag].style.color = '#3963AE'
      spans[tag].style.fontWeight = 600
      lis[tag].style.borderBottom = '3px solid rgb(57,99,174)'

    },
    phoneLink(name) {
      let url = '/gotosigao/' + name
      this.$router.push(url)
    },
    site(index, name, query) {
      let url = '/gotosigao/' + name
      let lis = document.querySelectorAll('.site')
      let spans = document.querySelectorAll('.siteSpan')
      this.navName = query
      for (let i = 0; i < lis.length; i++) {
        lis[i].style.borderBottom = '0 solid rgb(57,99,174)'
        spans[i].style.color = '#000000'
        spans[i].style.fontWeight = 500
      }
      spans[index].style.color = '#3963AE'
      spans[index].style.fontWeight = 600
      lis[index].style.borderBottom = '3px solid rgb(57,99,174)'
      this.$router.push(url)
    },
    getNavName(name) {
      let tagName = name || '公司简介'
      this.navName = tagName
    },
    gocenter() {
      document.body.scrollTop = 500
      document.documentElement.scrollTop = 500
      window.pageXOffset = 500
    },
    goTop() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      window.pageXOffset = 0
    },
    imgLoad(){
      // setTimeout(()=>{
      //   this.imgHeight = this.$refs.image[0].height
      // },500)
      let scrollWidth = document.body.scrollWidth
      if (scrollWidth < 1366) {
        setTimeout(()=>{
          this.imgHeight = this.$refs.image[0].height
        },500)
      } else {
        setTimeout(()=>{
          this.imgHeight = this.$refs.image[0].height
        },200)
      }
    },
    resize(){
      this.imgHeight = this.$refs.image[0].height
    }
  },
  mounted() {
    this.initBanner()
    this.imgLoad()
    this.$EventBus.$on("gosigaoCent", () => {
      this.gocenter()
    })
    this.$EventBus.$on("gosigaoTop", () => {
      this.goTop()
    })
    this.$EventBus.$on("navChange", (name) => {
      this.getNavName(name)
    })
    this.$EventBus.$on("initStyle", (index) => {
      this.initStyle(index)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize',this.resize,true)
    this.$EventBus.$off('routercanve')
    this.$EventBus.$off("navChange")
    this.$EventBus.$off('gosigaoCent')
    this.$EventBus.$off("gosigaoTop")
  }
}
</script>

<style scoped>
.banner{
  width: 100%;
  height: auto;
}
.sigaotitlebg {
  width: 100%;
  height: auto;
}

.sigaotitlebg .bgtitle {
  width: 240px;
  height: auto;
  position: absolute;
  left: 20%;
  top: 20%;
}

.sigaotitlebg .bgtitle h1 {
  font-size: 50px;
  font-family: 'PingFangSC-Medium';
  color: #ffffff;
  margin: 0 0 30px 0;
  padding: 0;
  font-weight: 400;
}

.sigaotitlebg .bgtitle span {
  font-size: 28px;
  font-family: 'Arial-BoldMT';
  color: #ffffff;
}

.navcontainer {
  width: 100%;
  height: 50px;
  background-color: rgb(246, 248, 251);
}

.navcontainer .navmain {
  width: 300px;
  height: 50px;
  display: flex;
  align-items: center;
  position: relative;
  left: 200px;
}

.navcontainer .navmain span {
  font-family: 'PingFang SC', 'PingFang SC-Regular';
  margin-right: 5px;
  font-size: 16px;
}

.sigaobody {
  width: 100%;
  height: auto;
}

.switchTab {
  width: 100%;
  height: auto;
  position: relative;
  top: 40px;
  margin-bottom: 100px;

}

.switchTab .tabMain {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #e1e2e3;
}

.switchTab .tabMain .tabtitle {
  width: 1100px;
  height: 60px;
  margin: 0 auto;
  text-align: center;
}

.switchTab .tabMain .tabtitle ul li{
  color: #000000;
}

.switchTab .tabBody {
  width: 100%;
  height: auto;
  position: relative;
  margin: 30px auto;
}

.switchTab .tabMain ul {
  margin: 0;
  padding: 0;
}

.switchTab .tabMain ul li {
  list-style: none;
  display: inline-block;
  width: 200px;
  height: 60px;
  text-align: center;
  border-bottom: 0 solid rgb(57, 99, 174);
  cursor: pointer;
  margin: 0 10px;
}

.switchTab .tabMain ul li:hover {
  border-bottom: 3px solid rgb(57, 99, 174);
}

.switchTab .tabMain ul li span {
  font-size: 24px;
  font-family: 'PingFang SC', 'PingFang SC-Bold';
  font-weight: 500;
  color: rgb(128, 141, 154);
}

.phoneTab {
  width: 100%;
  display: none;
}

.phoneTabTitle {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 0.5px solid #EBEEF5;
}

.phoneTabTitle span {
  font-size: 14px;
}

@media screen and (max-width: 996px) {
  .sigaotitlebg .bgtitle {
    top: 10%;
    left: 10%;
  }
}

@media screen and (max-width: 664px) {
  .sigaotitlebg .bgtitle {
    top: 12%;
    left: 12%;
  }

  .sigaotitlebg .bgtitle h1 {
    font-size: 30px;
    margin: 0 0 10px 0;

  }

  .sigaotitlebg .bgtitle span {
    font-size: 10px;

  }
}

@media screen and (max-width: 1200px) {
  .switchTab .tabMain {
    display: none;
  }

  .phoneTab {
    display: block;
  }

  .switchTab {
    top: -4px;
  }
}

</style>

<style>
#ball1 {
  width: 210px;
  height: 296px;
  opacity: 0.1;
  background: linear-gradient(68deg, #ffffff 23%, #006aa7 100%);
  border-radius: 50%;
  position: absolute;
  left: -100px;
}

#ball2 {
  width: 124px;
  height: 124px;
  opacity: 0.1;
  background: linear-gradient(211deg, #ffffff 39%, #006aa7 100%);
  border-radius: 50%;
  position: absolute;
  top: 1150px;
  left: 1500px;
}

#ball3 {
  width: 124px;
  height: 124px;
  opacity: 0.1;
  background: linear-gradient(211deg, #ffffff 39%, #006aa7 100%);
  border-radius: 50%;
  position: absolute;
  top: 1100px;
  left: 100px;
}

.phoneTab .el-collapse-item__header span {
  font-size: 16px;
  position: relative;
  left: 2%;
}

.phoneTab .el-collapse-item__content {
  padding: 0;
}

</style>
